import React, { useState } from 'react';
import MyExpenseReports from './MyExpenseReports';
import NewExpenseReport from './NewExpenseReport';
import ExpenseApprovalCenter from './ExpenseApprovalCenter';
import ExpenseStatements from './ExpenseStatements';
import ExpenseDetailModal from './ExpenseDetailModal';

// This is the main router for the Expense section.
export default function ExpenseModule({ userProfile, showModal, appId }) {
    const [expenseView, setExpenseView] = useState('myReports');
    const [selectedReport, setSelectedReport] = useState(null);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

    // This handler opens the detail modal or switches to edit view
    const handleSelectReport = (report) => {
        setSelectedReport(report);
        
        // --- THIS IS THE KEY LOGIC ---
        // If a report is rejected, it switches the view to 'editReport'
        // so the user can edit and resubmit it.
        // --- MODIFIED: The condition now checks for both rejection statuses ---
        if (report.status === 'Rejected' || report.status === 'Rejected by Finance') {
            setExpenseView('editReport');
        } else {
            setIsDetailModalOpen(true);
        }
    };

    const handleCancel = () => {
        setExpenseView('myReports');
        setSelectedReport(null);
    };

    let currentViewComponent;
    switch(expenseView) {
        case 'newReport':
            currentViewComponent = <NewExpenseReport userProfile={userProfile} showModal={showModal} appId={appId} onCancel={handleCancel} />;
            break;
        case 'editReport':
             currentViewComponent = <NewExpenseReport 
                                        userProfile={userProfile}
                                        key={selectedReport.id} // Use key to force re-mount when item changes
                                        initialData={selectedReport} 
                                        showModal={showModal}
                                        onCancel={handleCancel} 
                                        appId={appId}
                                    />;
            break;
        case 'approvalCenter':
            currentViewComponent = <ExpenseApprovalCenter userProfile={userProfile} showModal={showModal} appId={appId} />;
            break;
        case 'statements':
            currentViewComponent = <ExpenseStatements userProfile={userProfile} appId={appId} />;
            break;
        case 'myReports':
        default:
            currentViewComponent = <MyExpenseReports userProfile={userProfile} onSelectReport={handleSelectReport} appId={appId} />;
            break;
    }

    return (
        <div>
            <ExpenseNav setExpenseView={setExpenseView} activeView={expenseView} />
            <div className="mt-6">
                {currentViewComponent}
            </div>
            {isDetailModalOpen && 
                <ExpenseDetailModal 
                    report={selectedReport} 
                    onClose={() => setIsDetailModalOpen(false)} 
                    appId={appId}
                />
            }
        </div>
    );
}

// Sub-component for navigation within the Expense Module
function ExpenseNav({ setExpenseView, activeView }) {
    const NavButton = ({ viewName, children }) => {
        const isActive = activeView === viewName;
        return (
            <button
                onClick={() => setExpenseView(viewName)}
                className={`px-4 py-2 text-sm font-medium rounded-md transition ${
                    isActive ? 'bg-[#213368] text-white' : 'bg-white text-gray-600 hover:bg-gray-100'
                }`}
            >
                {children}
            </button>
        );
    };

    return (
        <div className="bg-white p-2 rounded-lg shadow-sm border flex items-center space-x-2">
            <NavButton viewName="myReports">My Expense Reports</NavButton>
            <NavButton viewName="newReport">New Expense Report</NavButton>
            <NavButton viewName="approvalCenter">Expense Approval Center</NavButton>
            <NavButton viewName="statements">Expense Statements</NavButton>
        </div>
    );
}

